import { GeneralModel } from "./general.model";

export class Service extends GeneralModel {
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_crm_angular/src/app/models/service.model.ts